<template>
    <BreadCrumb PageTitle="Ajouter un Incoterm" />
    <AddModalIncoterm />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddModalIncoterm from "@/components/Incoterm/AddModalIncoterm.vue";
  
    export default defineComponent({
      name: "AddIncotermPage",
      components: {
        BreadCrumb,
        AddModalIncoterm,
      },
    });
  </script>